import { HStack, Text } from "@chakra-ui/react";
import { ReactElement } from "react";
import CountryFlag from "./CountryFlag";


interface CountryProps {
    code: string;
    name: string;
}

const Country = ({ code, name, ...props }: CountryProps): ReactElement =>
    <HStack>
        <CountryFlag code={code} {...props} />
        <Text>{name}</Text>
    </HStack>

export default Country;